// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"ddc019ea","437":"56562f1c","1384":"ddc019ea","2705":"ddc019ea","3855":"ddc019ea","5911":"ddc019ea","7060":"ddc019ea","8487":"ddc019ea"}[chunkId] + ".chunk.css";
};